import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";
import { Constants } from "@/helpers/constants";

import { ILogger, LogLevel, HttpTransportType, HubConnectionBuilder, HubConnectionState } from "@microsoft/signalr";
import store from "@/store";
import router from '@/router';
import {
    StoreClassRoom, StoreContract, StoreHowToStudy,
    StoreLessonArea, StoreLessonGroup, StoreLessonKBS, StoreLesson, StoreLessonSubject, StoreLessonTeacher,
    StorePackage, StoreAppointment, StoreStudent, StoreTeacher, StoreUser, 
} from "@/store/constants";
import { UserService } from "@/services/api/user";

const dataListener = {
    connection: null,
    startPromise: null,
    stopPromise: null,
    retryTimer: null,
    enabled: false
};

export const DataListenerService = {
    wait: false,

    BindHandlers(connection) {
        const bus = appData.eventBus([Constants.Key.SnapData]);

        const canProcess = () =>
            dataListener.enabled &&
            dataListener.connection === connection;

        connection.on("receiveError", (error) => {
            if (!canProcess()) {
                return;
            }

            console.warn("Received error:", error);
        });

        connection.on("receiveDataChange", (model, changeDate) => {
            if (!canProcess()) {
                return;
            }

            try {
                const user = store.getters[StoreUser.get];

                const payload = {
                    reset: true,
                    callback: () => {
                        if (canProcess()) {
                            bus.set(Constants.Key.SnapData, {
                                model,
                                changeDate
                            });
                        }
                    }
                };

                switch (model) {
                    case Constants.DataModel.ClassRooms: store.dispatch(StoreClassRoom.loadList, payload); break;
                    case Constants.DataModel.Contacts: store.dispatch(StoreContract.loadList, payload); break;
                    case Constants.DataModel.UserContracts: store.dispatch(StoreContract.loadListRequired, payload); break;
                    //case Constants.DataModel.GlobalFileCategorys: store.dispatch(StoreGlobalFileCategory.loadList, payload); break;
                    //case Constants.DataModel.GlobalFiles: store.dispatch(StoreGlobalFile.loadList, payload); break;
                    case Constants.DataModel.HowToStudys: store.dispatch(StoreHowToStudy.loadList, payload); break;
                    case Constants.DataModel.LessonAreas: store.dispatch(StoreLessonArea.loadList, payload); break;
                    case Constants.DataModel.LessonGroups: store.dispatch(StoreLessonGroup.loadList, payload); break;
                    case Constants.DataModel.LessonKBSs: store.dispatch(StoreLessonKBS.loadList, payload); break;
                    case Constants.DataModel.Lessons: store.dispatch(StoreLesson.loadList, payload); break;
                    case Constants.DataModel.LessonSubjects: store.dispatch(StoreLessonSubject.loadList, payload); break;
                    case Constants.DataModel.LessonTeachers:
                    case Constants.DataModel.LessonTeacherRelations: store.dispatch(StoreLessonTeacher.loadList, payload); break;
                    //case Constants.DataModel.PastYearQuestions: store.dispatch(StorePastYearQuestions.loadList, payload); break;
                    case Constants.DataModel.Packages:
                    case Constants.DataModel.Plans: store.dispatch(StorePackage.loadList, payload); break;
                    //case Constants.DataModel.ResourceBooks: store.dispatch(StoreResourceBook.loadList, payload); break;
                    //case Constants.DataModel.TestPools: store.dispatch(StoreTestPoolsm.loadList, payload); break;
                    case Constants.DataModel.Appointments:
                    case Constants.DataModel.Meetings:
                        payload.isStudent = (user.userType == Enums.USER_TYPE.STUDENT);
                        store.dispatch(StoreAppointment.loadList, payload);
                        break;
                    case Constants.DataModel.StudentTeachers:
                        if (user.userType == Enums.USER_TYPE.STUDENT) {
                            store.dispatch(StoreTeacher.load, payload);
                        }
                        else if (user.userType == Enums.USER_TYPE.TEACHER) {
                            store.dispatch(StoreStudent.loadList, payload);
                        }
                        break;
                    //case Constants.DataModel.StudentRoutines:
                    //    break;
                    default:
                        console.log(`${model}, ${new Date(changeDate)}`);
                        bus.set(Constants.Key.SnapData, { model: model, changeDate: changeDate });
                        break;
                }
            } catch (error) {
                console.warn("Error processing data change:", error);
            }
        });

        connection.on("receiveDataGet", (data) => {
            if (!canProcess()) {
                return;
            }

            try {
                const user = store.getters[StoreUser.get];

                const {
                    announcement,
                    classRoom,
                    contract,
                    globalFileCategory,
                    globalFile,
                    howToStudy,
                    lessonArea,
                    lessonGroup,
                    lessonKBS,
                    lesson,
                    lessonSubject,
                    lessonTeacher,
                    lessonTeacherRelation,
                    pastYearQuestion,
                    packages,
                    plan,
                    resourceBook,
                    testPool,
                    appointment,
                    meeting,
                    userContract,
                    studentTeacher
                } = data;

                const payload = { detect: null, callback: () => { console.log("Veri yenilendi:" + model); } };

                //if (announcement) {
                //    payload.detect = new Date(announcement).getTime();
                //    store.dispatch(StoreAnnouncement.loadList, { ...payload });
                //}
                if (classRoom) {
                    payload.detect = new Date(classRoom).getTime();
                    store.dispatch(StoreClassRoom.loadList, { ...payload });
                }
                if (contract) {
                    payload.detect = new Date(contract).getTime();
                    store.dispatch(StoreContract.loadList, { ...payload });
                }
                //if (globalFileCategory) {
                //    payload.detect = new Date(globalFileCategory).getTime();
                //    store.dispatch(StoreGlobalFileCategory.loadList, { ...payload });
                //}
                //if (globalFile) {
                //    payload.detect = new Date(globalFile).getTime();
                //    store.dispatch(StoreGlobalFile.loadList, { ...payload });
                //}
                if (howToStudy) {
                    payload.detect = new Date(howToStudy).getTime();
                    store.dispatch(StoreHowToStudy.loadList, { ...payload });
                }
                if (lessonArea) {
                    payload.detect = new Date(lessonArea).getTime();
                    store.dispatch(StoreLessonArea.loadList, { ...payload });
                }
                if (lessonGroup) {
                    payload.detect = new Date(lessonGroup).getTime();
                    store.dispatch(StoreLessonGroup.loadList, { ...payload });
                }
                if (lessonKBS) {
                    payload.detect = new Date(lessonKBS).getTime();
                    store.dispatch(StoreLessonKBS.loadList, { ...payload });
                }
                if (lesson) {
                    payload.detect = new Date(lesson).getTime();
                    store.dispatch(StoreLesson.loadList, { ...payload });
                }
                if (lessonSubject) {
                    payload.detect = new Date(lessonSubject).getTime();
                    store.dispatch(StoreLessonSubject.loadList, { ...payload });
                }
                if (lessonTeacher) {
                    payload.detect = new Date(lessonTeacher).getTime();
                    store.dispatch(StoreLessonTeacher.loadList, { ...payload });
                }
                if (lessonTeacherRelation) {
                    payload.detect = new Date(lessonTeacherRelation).getTime();
                    store.dispatch(StoreLessonTeacher.loadList, { ...payload });
                }
                //if (pastYearQuestion) {
                //    payload.detect = new Date(pastYearQuestion).getTime();
                //    store.dispatch(StorePastYearQuestion.loadList, { ...payload });
                //}
                if (packages) {
                    payload.detect = new Date(packages).getTime();
                    store.dispatch(StorePackage.loadList, { ...payload });
                }
                if (plan) {
                    payload.detect = new Date(plan).getTime();
                    store.dispatch(StorePackage.loadList, { ...payload });
                }
                //if (resourceBook) {
                //    payload.detect = new Date(resourceBook).getTime();
                //    store.dispatch(StoreResourceBook.loadList, { ...payload });
                //}
                //if (testPool) {
                //    payload.detect = new Date(testPool).getTime();
                //    store.dispatch(StoreTestPool.loadList, { ...payload });
                //}
                if (appointment) {
                    payload.detect = new Date(appointment).getTime();
                    payload.isStudent = (user.userType == Enums.USER_TYPE.STUDENT);
                    store.dispatch(StoreAppointment.loadList, { ...payload });
                }
                if (meeting) {
                    payload.detect = new Date(meeting).getTime();
                    payload.isStudent = (user.userType == Enums.USER_TYPE.STUDENT);
                    store.dispatch(StoreAppointment.loadList, { ...payload });
                }
                if (userContract) {
                    payload.detect = new Date(userContract).getTime();
                    store.dispatch(StoreContract.loadListRequired, { ...payload });
                }
                if (studentTeacher) {
                    payload.detect = new Date(studentTeacher).getTime();
                    if (user.userType == Enums.USER_TYPE.STUDENT) {
                        store.dispatch(StoreTeacher.load, { ...payload });
                    }
                    else if (user.userType == Enums.USER_TYPE.STUDENT) {
                        store.dispatch(StoreStudent.loadList, { ...payload });
                    }
                }

            } catch (error) {
                console.warn("Error processing data get:", error);
            }
        });
    },

    async ListenServer() {
        const service = this;

        if (dataListener.stopPromise) {
            await dataListener.stopPromise;
        }

        if (dataListener.startPromise) {
            return dataListener.startPromise;
        }

        if (
            dataListener.connection &&
            dataListener.connection.state !== HubConnectionState.Disconnected
        ) {
            return dataListener.connection.state !== HubConnectionState.Disconnecting;
        }

        dataListener.enabled = true;

        clearTimeout(dataListener.retryTimer);
        dataListener.retryTimer = null;

        const retry = () => {
            if (!dataListener.enabled || dataListener.retryTimer !== null) {
                return;
            }

            dataListener.retryTimer = setTimeout(() => {
                dataListener.retryTimer = null;

                if (
                    dataListener.enabled &&
                    router.currentRoute.value.meta.theme === Enums.THEME.CLASSIC
                ) {
                    service.ListenServer().catch((error) => {
                        console.warn("Data listener retry error:", error);
                    });
                }
            }, 5000);
        };

        dataListener.startPromise = Promise.resolve().then(async () => {
            const loggedIn = await UserService.GetTokenIsLogin();

            if (!dataListener.enabled) {
                return false;
            }

            if (!loggedIn) {
                retry();
                return false;
            }

            if (!dataListener.connection) {
                const connection = new HubConnectionBuilder()
                    .withUrl(appData.serverBase + "hubs/user/data", {
                        accessTokenFactory: () =>
                            UserService.GetAccessRefreshToken(),
                        transport: HttpTransportType.WebSockets
                    })
                    .configureLogging(LogLevel.Critical)
                    .withAutomaticReconnect([0, 3000, 5000, 10000])
                    .build();

                dataListener.connection = connection;

                service.BindHandlers(connection);
                connection.onclose(retry);
            }

            await dataListener.connection.start();

            return (
                dataListener.enabled &&
                dataListener.connection?.state === HubConnectionState.Connected
            );
        }).catch((error) => {
            console.error("Data listener connection error:", error);
            retry();
            throw error;
        }).finally(() => {
            dataListener.startPromise = null;
        });

        return dataListener.startPromise;
    },

    StopListenServer() {
        if (dataListener.stopPromise) {
            return dataListener.stopPromise;
        }

        dataListener.enabled = false;

        clearTimeout(dataListener.retryTimer);
        dataListener.retryTimer = null;

        dataListener.stopPromise = Promise.resolve().then(async () => {
            if (dataListener.startPromise) {
                await dataListener.startPromise.catch(() => {});
            }

            const connection = dataListener.connection;
            dataListener.connection = null;

            if (connection) {
                await connection.stop();
            }
        }).finally(() => {
            dataListener.stopPromise = null;
        });

        return dataListener.stopPromise;
    }
};